/* ---- Shared helpers for ChatView sub-components ---- */

export function generateId(): string {
  return `${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
}

export function decodeBase64Utf8(base64: string): string {
  const bytes = Uint8Array.from(atob(base64), (c) => c.charCodeAt(0));
  return new TextDecoder().decode(bytes);
}

export function formatFileSize(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

export function fileCategory(type: string): 'image' | 'video' | 'audio' | 'other' {
  if (type.startsWith('image/')) return 'image';
  if (type.startsWith('video/')) return 'video';
  if (type.startsWith('audio/')) return 'audio';
  return 'other';
}

export function fileExt(name: string): string {
  const parts = name.split('.');
  return parts.length > 1 ? parts[parts.length - 1].toLowerCase() : '';
}

const textExts = new Set([
  'txt', 'md', 'markdown', 'json', 'xml', 'yaml', 'yml', 'toml', 'ini', 'cfg', 'conf',
  'js', 'jsx', 'ts', 'tsx', 'mjs', 'cjs', 'vue', 'svelte',
  'py', 'rb', 'go', 'rs', 'java', 'kt', 'scala', 'c', 'cpp', 'h', 'hpp', 'cs',
  'sh', 'bash', 'zsh', 'fish', 'ps1', 'bat', 'cmd',
  'css', 'scss', 'less', 'sass',
  'sql', 'graphql', 'gql',
  'env', 'gitignore', 'dockerignore', 'editorconfig',
  'csv', 'tsv', 'log', 'diff', 'patch',
]);

export function isTextPreviewable(name: string, type: string): boolean {
  const ext = fileExt(name);
  if (textExts.has(ext)) return true;
  if (type.startsWith('text/')) return true;
  if (type === 'application/json' || type === 'application/xml') return true;
  return false;
}

export function isEmbedPreviewable(name: string): boolean {
  const ext = fileExt(name);
  return ext === 'pdf' || ext === 'html' || ext === 'htm';
}

export function isOfficePreviewable(name: string): 'docx' | 'xlsx' | 'pptx' | false {
  const ext = fileExt(name);
  if (ext === 'docx') return 'docx';
  if (ext === 'xlsx' || ext === 'xls') return 'xlsx';
  if (ext === 'pptx') return 'pptx';
  return false;
}

export function serverPreviewUrl(fileUrl: string): string {
  return fileUrl.startsWith('/api/files/')
    ? fileUrl.replace('/api/files/', '/api/files/preview/')
    : fileUrl;
}
